import React from 'react';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import About from './components/About';
import Contact from './components/Contact';
import Services from './components/Services';
import Artist from './components/Artist';
import Gallery from './components/Gallery';
import Loader from './components/Loader';
import { LanguageProvider } from './context/LanguageContext';

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        {/* Loader will be shown until page is fully loaded with a minimum display time */}
        <Loader minLoaderTime={2000} />
        <Header />
        <main>
          <Home />
          <About />
          <Artist />
          <Gallery />
          <Services />
          <Contact />
        </main>
        <Footer />
        <a href="https://wa.me/40743463712" target="_blank" rel="noopener noreferrer" className="whatsapp-float">
          <i className="fab fa-whatsapp"></i>
        </a>
      </div>
    </LanguageProvider>
  );
}

export default App;
